import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  fan1,
  refrigerator3,
  dispenser1,
  geyser1,
} from "../../../assets/images/index";

const SpecialOffers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Special Offers" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1101"
          img={fan1}
          productName="Royal Deluxe Ceiling Fan"
          price="9900"
          color="Royal"
          badge={false}
          offer={true} 
          des="The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space. "
        />
        <Product
          _id="1102"
          img={refrigerator3}
          productName="DAWLANCE NON INVERTER REFRIGERATOR Model 91999 CHROME HB"
          price="123000"
          color="DAWLANCE"
          badge={false}
          offer1={true} 
          des="The 91999 Chrome Hairline Black is a double door refrigerator from Dawlance. It’s designed with a sleek chrome hairline black finish and offers a spacious interior for all your food storage needs. It uses Vitamin Fresh Technology to preserve the maximum level of Vitamin A and C in fruits and vegetables, ensuring the health and immunity of your family."
        />
        <Product
          _id="1103"
          img={dispenser1}
          productName="DAWLANCE THREE TAP GLASS DOOR WATER DISPENSER Model 1051 GLASS DOOR NOIR RED"
          price="44100"
          color="DAWLANCE"
          badge={false}
          offer2={true} 
          des="The 1051 Glass Door Noir Red With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
        />
        <Product
          _id="1104"
          img={geyser1}
          productName="CANON ELECTRIC STORAGE GEYSER 30 LITER Model EWT 3021"
          price="25500"
          color="CANON"
          badge={false}
          offer3={true} 
          des="The Canon EWT 3021 is a 30-liter electric storage geyser that provides a reliable and efficient solution for your hot water needs. It’s designed to provide a steady supply of hot water for your home, ensuring you never run out of hot water when you need it."
        />
      </div>
    </div>
  );
};

export default SpecialOffers;
